class CardGridWide {
    constructor() {
        this.init();
    }

    init() {
        // Only initialize if ScrollTrigger exists
        if (typeof ScrollTrigger !== 'undefined') {
            this.initScrollTriggers();
        }
    }

    initScrollTriggers() {
        // Use matchMedia to only apply this on screens less than 992px
        ScrollTrigger.matchMedia({
            "(max-width: 991px)": () => {
                const cards = document.querySelectorAll('.c-card.cc-card_grid_wide');
                
                cards.forEach(card => {
                    let cardOverlay = card.querySelector('.c-card_overlay');
                    ScrollTrigger.create({
                        trigger: card,
                        start: "top center+=25%", // when card reaches 25% from center (top)
                        end: "top 15%", // when card reaches 25% from center (bottom)
                        toggleActions: "play reverse play reverse",
                        animation: gsap.to(cardOverlay, {
                            opacity: 0,
                            duration: .3,
                            ease: "power2.inOut"
                        })
                    });
                });
            }
        });
    }

    destroy() {
        // Clean up ScrollTrigger instances when component is destroyed
        ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    }
}

export default CardGridWide;